import { Link } from "react-router-dom";
import { useConsent } from "../../contexts/ConsentContext";

const focus = "focus-visible:ring-2 focus-visible:ring-brand-700/30 focus-visible:ring-offset-2 focus-visible:outline-none";

const FooterNew = ({ footerData, headerlogo }) => {
  const { openSettings } = useConsent();
  const year = new Date().getFullYear();

  const columns = [
    {
      title: "Company",
      links: [
        { label: "About", to: "/about" },
        { label: "Team", to: "/about" },
        { label: "Contact", to: "/contact" },
      ],
    },
    {
      title: "Product",
      links: [
        { label: "How It Works", to: "/how-it-works" },
        { label: "Features", to: "/#features" },
      ],
    },
  ];

  return (
    <footer className="relative z-20 bg-white border-t border-neutral-100">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 lg:px-20 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand column */}
          <div className="col-span-1 flex flex-col gap-4">
            <Link to="/" className={`flex items-center gap-2 no-underline rounded-sm ${focus}`}>
              {(footerData?.footerLogo || headerlogo) ? (
                <img src={footerData?.footerLogo || headerlogo} alt="OrthoPed" className="h-8" />
              ) : (
                <>
                  <span className="material-symbols-outlined text-2xl font-bold text-brand-700">
                    orthopedics
                  </span>
                  <span className="font-display text-lg font-bold tracking-tight">
                    <span className="text-brand-700">Ortho</span>
                    <span className="text-brand-500">Ped</span>
                  </span>
                </>
              )}
            </Link>
            <p className="text-neutral-500 text-sm leading-relaxed">
              {footerData?.footerTagline || "Redefining musculoskeletal health through integrated technology and clinical excellence."}
            </p>
            <a
              href={`mailto:${footerData?.footerEmail || "info@orthoped.ai"}`}
              className={`text-brand-700 text-sm font-medium no-underline hover:text-brand-500 transition-colors rounded-sm ${focus}`}
            >
              {footerData?.footerEmail || "info@orthoped.ai"}
            </a>
          </div>

          {/* Link columns */}
          {columns.map((col) => (
            <div key={col.title} className="flex flex-col gap-4">
              <h4 className="font-display font-bold text-neutral-900 text-sm uppercase tracking-wider">
                {col.title}
              </h4>
              <nav className="flex flex-col gap-3">
                {col.links.map((link) => (
                  <Link
                    key={link.label}
                    to={link.to}
                    className={`text-neutral-500 text-sm no-underline hover:text-brand-700 transition-colors duration-base rounded-sm ${focus}`}
                  >
                    {link.label}
                  </Link>
                ))}
              </nav>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-neutral-100 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-neutral-400 text-xs">
            {footerData?.copywright || `© ${year} OrthoPed. All rights reserved.`}
          </p>
          <div className="flex gap-6">
            <Link
              to="/privacy-policy"
              className={`text-neutral-400 text-xs no-underline hover:text-brand-700 transition-colors rounded-sm ${focus}`}
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-of-service"
              className={`text-neutral-400 text-xs no-underline hover:text-brand-700 transition-colors rounded-sm ${focus}`}
            >
              Terms of Service
            </Link>
            <button
              onClick={openSettings}
              className={`text-neutral-400 text-xs hover:text-brand-700 transition-colors rounded-sm bg-transparent border-none cursor-pointer p-0 ${focus}`}
            >
              Cookie Settings
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterNew;
